// extracted by mini-css-extract-plugin
export default {"communicationItem":"MessengerIcon_communicationItem__TXgA7"};